import React, { useState, useEffect, useRef, useCallback } from "react";
import classes from "./style.module.css";
import AnimatedPageContainer from "../../assets/containers/AnimatedPageContainer";
import PointShopFilter from "./PointShopFilter";

import PrizePlaceHolder from "../../assets/images/pointsShop/pointsPlaceHolder.png";
import RCoin from "../../assets/images/icons/RCoin.png";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

import appApi from "../../assets/utils/AppApi";
import { baseURL } from "../../assets/constants/baseUrl";
import Loading from "../../assets/containers/loadingDialog";
import errorHandler from "../../assets/utils/ErrorHandler";
import NoResultAlter from "../../assets/components/UI/NoResultAlter";

const itemVariants = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: { opacity: 1, scale: 1 },
};

const PointShop = () => {
  const [filter, setFilter] = useState("");
  const [items, setitems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totPages, setTotPages] = useState(1);
  const [page, setPage] = useState(1);
  const observer = useRef();

  const getItems = async (page) => {
    setLoading(true);
    try {
      await appApi
        .get(`/pointshop/item/getall/user?page=${page}&limit=10`)
        .then(({ data }) => {
          setTotPages(data.totalPages);
          setitems((prevItems) => [...prevItems, ...data.docs]);
          setLoading(false);
        });
    } catch (error) {
      errorHandler(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getItems(page);
  }, [page]);

  const lastElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && page < totPages) {
          setPage((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading, page, totPages]
  );

  return (
    <AnimatedPageContainer>
      <div className="customContainer">
        <PointShopFilter
          selected={filter}
          handleClick={(type) => setFilter(type)}
        />
        <div className="row p-0 m-0 justify-content-between  align-items-stretch">
          {!loading && items.length === 0 ? (
            <NoResultAlter
              className={"w-100  py-5 my-5"}
              text={
                <>
                  ویترین جوایز جدید،
                  <br />
                  به زودی...
                </>
              }
            />
          ) : (
            items.map((item, index) => (
              <div className="col-6 p-1 py-2" key={item._id}>
                <motion.div
                  className={` ${classes.prizeCard} h-100`}
                  variants={itemVariants}
                  initial="hidden"
                  animate="visible"
                  transition={{ duration: 0.3, delay: index * 0.2 }}
                  ref={index === items.length - 1 ? lastElementRef : null}
                >
                  <div>
                    <img
                      src={
                        item.cover
                          ? `${baseURL}file/get/${item.cover}`
                          : PrizePlaceHolder
                      }
                      alt="placholder"
                      crossOrigin="anonymous"
                      className={classes.prizeImg}
                    />
                    <p className={classes.prizeTitle}>{item.name}</p>
                  </div>
                  <div>
                    <div className={classes.prizeCoin}>
                      <span>{item.price}</span>
                      <img src={RCoin} alt="coin" />
                    </div>
                    {item.inventory === 0 ? (
                      <button style={{ opacity: "0.5", cursor: "not-allowed" }}>
                        به زودی
                      </button>
                    ) : (
                      <Link to={`/pointShopDetails/${item._id}`}>
                        <button>مشاهده</button>
                      </Link>
                    )}
                  </div>
                </motion.div>
              </div>
            ))
          )}
          {loading && (
            <Loading
              className={"w-100 d-flex justify-content-center my-5 py-5"}
            />
          )}
        </div>
      </div>
    </AnimatedPageContainer>
  );
};

export default PointShop;
